/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-use-before-define */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-template */
/* eslint-disable no-lonely-if */
/* eslint-disable react/jsx-one-expression-per-line */
// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { useFormik } from 'formik';
import { useParams } from 'react-router-dom';
// COMPONENTS
import ReactTable from 'react-table';
import { Alert } from 'react-bootstrap';
// ICONS
import { TbCurrencyDollar } from 'react-icons/tb';
import { HiOutlineTrash, HiOutlinePencilAlt } from 'react-icons/hi';
import { MdAddBox, MdDelete } from 'react-icons/md';
// CUSTOM COMPONENTS
import Overlay from '../../../../components/Overlay';
import Section from '../../../../components/Section';
import ContentBlock from '../../../../components/ContentBlock';
import CustomBlock from '../../../../components/CustomBlock';
import FormBlock from '../../../../components/FormBlock';
import ContentHeader from '../../../../components/ContentHeader';
import SelectBlock from '../../../../components/SelectBlock';
import InputBlock from '../../../../components/InputBlock';
import Button from '../../../../components/Button';
import TextAreaBlock from '../../../../components/TextAreaBlock';
import ModalBlock from '../../../../components/ModalBlock';
import FixedActionsBar from '../../../../components/FixedActionsBar';
// REDUX
import * as alert from '../../../../redux/alertToastRedux';
import * as confirmModal from '../../../../redux/confirmModalRedux';
// SERVICES AND HELPERS
import * as clientService from '../../../../services/management/clientService';
import * as quoteService from '../../../../services/management/quoteService';
import * as quoteLineItemService from '../../../../services/management/quoteLineItemService';
import * as licensorService from '../../../../services/management/licensorService';
import * as connectionService from '../../../../services/management/connectionService';
import * as reportService from '../../../../services/report/reportService';
import * as helper from '../../../../helpers/helper';
import constants from '../../../../constants/constants';

const initialQuoteModel = {
  id: 0,
  clientId: null,
  quoteNo: '',
  multiplier: '',
  lineItems: []
};

const initialFilterSelectModel = {
  licensor: null,
  connectionType: null,
  materialGroup: null,
  size: null,
  weight: null,
  equipment: null
};

const QuoteManagementPage = (props) => {
  const {
    showAlert,
    history,
    showConfirmModal,
    hideConfirmModal
  } = props;
  const { quoteId } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [quote, setQuote] = useState(initialQuoteModel);
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [licensors, setLicensors] = useState([]);
  const [connectionTypes, setConnectionTypes] = useState([]);
  const [materialGroups, setMaterialGroups] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [weights, setWeights] = useState([]);
  const [selectedLineItemFilters, setSelectedLineItemFilters] = useState(initialFilterSelectModel);
  const [connections, setConnections] = useState([]);
  const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
  const [isEmailModalVisible, setIsEmailModalVisible] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [emailModel, setEmailModel] = useState({
    quoteId,
    emails: []
  });
  const [cancellationReason, setCancellationReason] = useState('');
  const [isRejectionModalVisible, setIsRejectionModalVisible] = useState(false);
  const initialUpdateLineItem = {
    id: quoteId,
    amount: 0,
    comments: ''
  };
  const [updateLineItemModel, setUpdateLineItemModel] = useState(initialUpdateLineItem);

  const initialLineItemModel = {
    id: 0,
    quoteId,
    licensor: '',
    connectionType: '',
    materialGroup: '',
    size: '',
    weight: '',
    quantity: '',
    amount: '',
    complexityMultiplier: '',
    comments: ''
  };
  const [lineItemModel, setLineItemModel] = useState(initialLineItemModel);
  const [masterLicensorList, setMasterLicensorList] = useState([]);

  useEffect(() => {
    if (quoteId) {
      populateForm();
      fetchLicensors();
    }
    fetchClients();
  }, []);

  useEffect(() => {
    setSelectedLineItemFilters({
      ...selectedLineItemFilters,
      connectionType: null,
      materialGroup: null,
      size: null,
      weight: null
    });
    if (selectedLineItemFilters.licensor) {
      const temp = masterLicensorList.find((x) => x.id === selectedLineItemFilters.licensor.value);
      if (temp) {
        setConnectionTypes(temp.connectionTypes.map((x) => helper.setToOptionModel(x.name, x.id)));
      }
    } else {
      setConnectionTypes([]);
    }
  }, [selectedLineItemFilters.licensor]);

  useEffect(() => {
    setSelectedLineItemFilters({
      ...selectedLineItemFilters,
      materialGroup: null,
      size: null,
      weight: null
    });
    if (selectedLineItemFilters.connectionType) {
      fetchConnections(selectedLineItemFilters.connectionType.value);
    } else {
      setMaterialGroups([]);
    }
  }, [selectedLineItemFilters.connectionType]);

  useEffect(() => {
    setSelectedLineItemFilters({
      ...selectedLineItemFilters,
      size: null,
      weight: null
    });
    if (selectedLineItemFilters.materialGroup) {
      const grouping = connections
        .filter((x) => x.group === selectedLineItemFilters.materialGroup.value);
      if (grouping) {
        setSizes(
          _.uniqBy(grouping, 'size')
            .slice()
            .sort((a, b) => parseFloat(a.size) - parseFloat(b.size))
            .map((x) => helper.setToOptionModel(x.size, x.size))
        );
      } else {
        setSizes([]);
      }
    } else {
      setSizes([]);
    }
  }, [selectedLineItemFilters.materialGroup]);

  useEffect(() => {
    setSelectedLineItemFilters({
      ...selectedLineItemFilters,
      weight: null
    });
    if (selectedLineItemFilters.size) {
      const grouping = connections
        .filter((x) => x.group === selectedLineItemFilters.materialGroup.value
          && x.size === selectedLineItemFilters.size.value);
      if (grouping) {
        setWeights(grouping.map((x) => helper.setToOptionModel(x.weight, x.weight)));
      } else {
        setWeights([]);
      }
    } else {
      setWeights([]);
    }
  }, [selectedLineItemFilters.size]);

  const lineItemFormik = useFormik({
    initialValues: lineItemModel,
    validationSchema: Yup.object().shape({
      id: Yup.number(),
      quoteId: Yup.number(),
      licensor: Yup.string().required(),
      connectionType: Yup.string().required(),
      materialGroup: Yup.string().required(),
      size: Yup.string().required(),
      weight: Yup.string().required(),
      quantity: Yup.number().required(),
      amount: Yup.number().required(),
      complexityMultiplier: Yup.number().nullable(),
      comments: Yup.string().nullable()
    }),
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      saveLineItem(values);
    },
  });

  useEffect(() => {
    if (
      selectedLineItemFilters.licensor && selectedLineItemFilters.connectionType
      && selectedLineItemFilters.materialGroup && selectedLineItemFilters.size
      && selectedLineItemFilters.weight && lineItemFormik.values.quantity
    ) {
      const obj = connections.find((x) => x.group === selectedLineItemFilters.materialGroup.value
        && x.size === selectedLineItemFilters.size.value
        && x.weight === selectedLineItemFilters.weight.value);
      const licensor = licensors.find((x) => x.value === selectedLineItemFilters.licensor.value);

      if (obj) {
        let amount = 0;
        const qty = lineItemFormik.values.quantity;

        if (licensor.isDifferent) {
          if (qty >= 40) {
            amount = obj.qty40Plus;
          } else if (qty >= 25) {
            amount = obj.qty25to100;
          } else if (qty >= 10) {
            amount = obj.qty10to24;
          } else if (qty >= 5) {
            amount = obj.qty5to9;
          } else if (qty >= 2) {
            amount = obj.qty2to4;
          } else {
            amount = obj.qty1;
          }
        } else {
          if (qty >= 51) {
            amount = obj.qty51to100;
          } else if (qty >= 31) {
            amount = obj.qty31to50;
          } else if (qty >= 21) {
            amount = obj.qty21to30;
          } else if (qty >= 16) {
            amount = obj.qty16to20;
          } else if (qty >= 11) {
            amount = obj.qty11to15;
          } else if (qty >= 6) {
            amount = obj.qty6to10;
          } else if (qty >= 3) {
            amount = obj.qty3to5;
          } else if (qty >= 2) {
            amount = obj.qty2;
          } else if (qty >= 1) {
            amount = obj.qty1;
          }
        }

        if (selectedLineItemFilters.equipment) {
          const { multiplier } = selectedLineItemFilters.equipment;
          amount = ((licensor.isDifferent
            ? multiplier
            : getMultiplierForNormalLicensor(multiplier)) * amount) / 100 + amount;

          lineItemFormik.setFieldValue('amount', amount.toFixed(2));
        }
        // if (lineItemFormik.values.complexityMultiplier) {
        //   const amt = (lineItemFormik.values.complexityMultiplier * amount) / 100 + amount;
        //   lineItemFormik.setFieldValue('amount', amt.toFixed(2));
        // } else {
        //   lineItemFormik.setFieldValue('amount', amount.toFixed(2));
        // }
      } else {
        showAlert({ text: 'Could not find the connection', state: 'warning' });
      }
    } else {
      lineItemFormik.setFieldValue('amount', '');
    }
  }, [
    selectedLineItemFilters,
    lineItemFormik.values.quantity,
    lineItemFormik.values.complexityMultiplier,
    lineItemFormik.values.equipment
  ]);

  const getMultiplierForNormalLicensor = (multiplier) => {
    if (multiplier === 26.5 || multiplier === 54) {
      return 10;
    }
    if (multiplier === 59.5) {
      return 54;
    }

    return multiplier;
  };

  const fetchClients = () => {
    setIsLoading(true);
    clientService.getAllClients('').then((res) => {
      setClients(res.map((x) => helper.setToOptionModel(`${x.name} ${x.clientNo ? ' - ' + x.clientNo : ''}`, x.id)));
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const fetchLicensors = () => {
    setIsLoading(true);
    licensorService.getAllLicensors(true).then((res) => {
      setLicensors(res.map((x) => ({
        label: x.name,
        value: x.id,
        isDifferent: x.isDifferent
      })));
      setMasterLicensorList(res);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const fetchConnections = (id) => {
    setIsLoading(true);
    connectionService.getConnections(id).then((res) => {
      setConnections(res);
      setMaterialGroups([]);
      const groups = _.uniqBy(res, 'group')
        .map((x) => x.group)
        .map((row) => ({
          label: row,
          value: row,
        }));
      setMaterialGroups(groups);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const updateLineItemFormik = useFormik({
    initialValues: updateLineItemModel,
    validationSchema: Yup.object().shape({
      id: Yup.number(),
      amount: Yup.number().required(),
      comments: Yup.string().nullable(),
    }),
    enableReinitialize: true,
    onSubmit: (values) => {
      updateAdditionalCost(values);
    },
  });

  const emailFormik = useFormik({
    initialValues: { email: '' },
    validationSchema: Yup.object().shape({ email: Yup.string().email().required() }),
    enableReinitialize: true,
    onSubmit: (values) => {
      emailModel.emails.push(values.email);
      emailFormik.resetForm();
    },
  });

  const updateAdditionalCost = (model) => {
    setIsLoading(true);
    quoteService.updateCostAndComment(model).then((res) => {
      populateForm();
      showAlert({ text: res.message, state: 'success' });
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
      handleLineItemUpdateModalClose();
    });
  };

  const handleLineItemUpdateModalClose = () => {
    setIsUpdateModalVisible(false);
    setTimeout(() => {
      setUpdateLineItemModel(initialUpdateLineItem);
      updateLineItemFormik.resetForm();
    }, 250);
  };

  const formik = useFormik({
    initialValues: quote,
    validationSchema: Yup.object().shape({
      id: Yup.number(),
      clientId: Yup.number(),
      quoteNo: Yup.string().nullable().max(500),
      sm: Yup.string().nullable().max(100),
      referencedInquiry: Yup.string().nullable().max(150),
      estimatedDelivery: Yup.string().nullable().max(150),
      fob: Yup.string().nullable().max(150),
      expiration: Yup.string().nullable().max(100),
      att1: Yup.string().nullable().max(150),
      att2: Yup.string().nullable().max(150),
    }),
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      if (quoteId) {
        updateQuote(values);
      } else {
        createQuote(values);
      }
    },
  });

  const populateForm = () => {
    setIsLoading(true);
    quoteService.getQuoteById(quoteId).then((res) => {
      setQuote(res);
      if (res.clientId) {
        setSelectedClient({ label: res.client, value: res.clientId });
      }
      setIsDisabled(res.dateCompleted !== null);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const createQuote = (model) => {
    setIsLoading(true);
    quoteService.createQuote(model).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      history.push(`/quote/${res.id}`);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'warning' });
    }).finally(() => setIsLoading(false));
  };

  const updateQuote = (model) => {
    setIsLoading(true);
    quoteService.updateQuote(model).then((res) => {
      showAlert({ text: res.message, state: 'success' });
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'warning' });
    }).finally(() => setIsLoading(false));
  };

  const deleteQuoteLineItem = (id) => {
    setIsLoading(true);
    hideConfirmModal();
    quoteLineItemService.deleteQuoteLineItem(id).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      populateForm();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'warning' });
    }).finally(() => setIsLoading(false));
  };

  const saveLineItem = (model) => {
    setIsLoading(true);
    quoteLineItemService.createQuoteLineItem({
      ...model,
      licensor: selectedLineItemFilters.licensor.label,
      connectionType: selectedLineItemFilters.connectionType.label
    }).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      populateForm();
      handleResetForm();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'warning' });
    }).finally(() => setIsLoading(false));
  };

  const columns = [
    {
      Header: 'Actions',
      accessor: 'id',
      minWidth: 20,
      show: !isDisabled,
      Cell: (tableProps) => {
        const { original } = tableProps;

        return (
          <CustomBlock className="content-container--actions flex-start pl-0 mt-0">
            <Button
              size="icon"
              className="info--bg"
              iconLeft={<HiOutlinePencilAlt className="white--clr" size={20} />}
              onClick={() => {
                setUpdateLineItemModel(original);
                setIsUpdateModalVisible(true);
              }}
            />

            <Button
              size="icon"
              className="danger--bg"
              iconLeft={<HiOutlineTrash className="white--clr" size={20} />}
              onClick={() => {
                showConfirmModal({
                  title: 'Delete Quote Line Item',
                  text: 'Are you sure you want to delete this quote line item?',
                  rightBtnText: 'Confirm',
                  btnAction: () => {
                    deleteQuoteLineItem(original.id);
                  }
                });
              }}
            />
          </CustomBlock>
        );
      }
    },
    {
      Header: 'Licensor',
      accessor: 'licensor',
      minWidth: 45,
    },
    {
      Header: 'Connection Type',
      accessor: 'connectionType',
      minWidth: 17,
    },
    {
      Header: 'Material Group',
      accessor: 'materialGroup',
      minWidth: 15,
    },
    {
      Header: 'Size',
      accessor: 'size',
      minWidth: 15,
    },
    {
      Header: 'Quantity',
      accessor: 'quantity',
      minWidth: 10,
    },
    {
      Header: 'Cost',
      accessor: 'amount',
      minWidth: 15,
      Cell: (tableProps) => {
        const { original } = tableProps;

        return (
          <p>
            $
            {original.amount && (original.amount).toFixed(2)}
          </p>
        );
      }
    },
    {
      Header: 'Total',
      accessor: 'total',
      minWidth: 15,
      Cell: (tableProps) => {
        const { original } = tableProps;

        return (
          <p>
            $
            {(original.quantity * original.amount).toFixed(2)}
          </p>
        );
      }
    },
    {
      Header: 'Comments',
      accessor: 'comments'
    },
  ];

  const handleResetForm = () => {
    setLineItemModel(initialLineItemModel);
    setSelectedLineItemFilters(initialFilterSelectModel);
    lineItemFormik.resetForm();
  };

  const getQuoteReport = () => {
    setIsLoading(true);
    reportService.getQuoteReport(quoteId).then((res) => {
      const win = window.open('about:blank', '_blank');
      win.document.title = 'K&B Industries | Quote';
      win.document.write(`<iframe width="100%" height="100%" src="data:application/pdf;base64,${res}" frameborder="0" allowfullscreen  style="position:fixed; top:0; left:0; bottom:0; right:0; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;"></iframe>`);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'warning' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const getClientEmail = () => {
    setIsLoading(true);

    clientService.getClientById(formik.values.clientId).then((res) => {
      if (res.client.contactEmail) {
        setEmailModel({ ...emailModel, emails: [res.client.contactEmail] });
      }
      setIsEmailModalVisible(true);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const submitToClient = () => {
    setIsLoading(true);
    setIsEmailModalVisible(false);

    quoteService.emailQuote(emailModel).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      history.push('/quotes');
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const setQuoteAsApproved = () => {
    setIsLoading(true);
    hideConfirmModal();
    quoteService.approveQuote(quoteId).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      history.push('/quotes');
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const handleRejectionModalClose = () => {
    setCancellationReason('');
    setIsRejectionModalVisible(false);
  };

  const handleQuoteRejection = () => {
    if (!cancellationReason) {
      showAlert({ text: 'Error! Rejection Reason is required', state: 'warning' });
      return;
    }
    setIsLoading(true);
    setIsRejectionModalVisible(false);
    quoteService.rejectQuote(quoteId, cancellationReason).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      history.push('/quotes');
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
      setCancellationReason('');
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const getVariant = (isApproved) => {
    if (isApproved == null) {
      return 'info';
    }

    return isApproved ? 'success' : 'danger';
  };

  return (
    <>
      {isLoading && <Overlay hasLoader />}
      <CustomBlock className="content-container--padded">
        <Section isFullWidth>
          <FormBlock className="content-container--card-style--with-shadow" onSubmit={formik.handleSubmit}>
            <ContentHeader
              title="Quote Details"
              headerSize="lg"
            />

            <Section hasNoContainer>
              {
                formik.values.quoteNo && (
                  <ContentBlock>
                    <ContentHeader
                      title={`Quote No: ${formik.values.quoteNo}`}
                      headerSize="md"
                      className="alt-font fw-600 primary-lighter--clr"
                      primaryButtonText={quoteId ? 'Download Quote' : ''}
                      primaryButtonOnClick={getQuoteReport}
                    />
                  </ContentBlock>
                )
              }

              {
                isDisabled && (
                  <Alert variant={getVariant(formik.values.isApproved)}>
                    <Alert.Heading>
                      Quote
                      {formik.values.isApproved === null && ' Submitted'}
                      {formik.values.isApproved === true && ' Approved'}
                      {formik.values.isApproved === false && ' Rejected'}
                    </Alert.Heading>
                    <p>
                      This quote was submmited to client on
                      {' '} {formik.values.dateCompleted}. {' '}
                      By: <b>{formik.values.completedBy}</b>
                    </p>
                    {
                      formik.values.isApproved === true && (
                        <p>
                          This quote was approved on {' '}
                          {formik.values.approvedRejectedDate}.
                          {' '} By: <b>{formik.values.approvedRejectedBy}</b>
                        </p>
                      )
                    }
                    {
                      formik.values.isApproved === false && (
                        <>
                          <p>
                            This quote was rejected on {' '}
                            {formik.values.approvedRejectedDate}.
                            {' '} By: <b>{formik.values.approvedRejectedBy}</b>
                          </p>
                          <p>
                            Rejection Reason: {' '}
                            <b>{formik.values.rejectionReason}</b>
                          </p>
                        </>
                      )
                    }
                    {
                      formik.values.isApproved === null && (
                        <>
                          <hr />

                          <div className="d-flex justify-content-end">
                            <Button
                              text="Approve"
                              size="xs"
                              className="primary--bg"
                              onClick={() => {
                                showConfirmModal({
                                  title: 'Approve Quote',
                                  text: 'Are you sure you want to approve this quote?',
                                  rightBtnText: 'Confirm',
                                  btnAction: () => {
                                    setQuoteAsApproved();
                                  }
                                });
                              }}
                            />
                            <Button
                              text="Reject"
                              size="xs"
                              className="danger--bg ml-10"
                              onClick={() => {
                                setIsRejectionModalVisible(true);
                              }}
                            />
                          </div>
                        </>
                      )
                    }

                  </Alert>
                )
              }

              <ContentBlock cols={3}>
                <SelectBlock
                  label="Customer"
                  placeholder="Select a customer"
                  options={clients}
                  isRequired
                  isDisabled={isDisabled}
                  value={selectedClient}
                  onChange={(opt) => {
                    opt = opt === null ? [] : opt;
                    setSelectedClient(opt);
                    formik.setFieldValue('clientId', opt.value);
                  }}
                />
              </ContentBlock>

              {
                quoteId && (
                  <>
                    <ContentBlock cols={1}>
                      <InputBlock
                        label="S/M"
                        placeholder="e.g. BS"
                        errorMessage={formik.errors.sm}
                        isDisabled={isDisabled}
                        inputState={`${helper.getInputClasses(formik, 'sm')}`}
                        {...formik.getFieldProps('sm')}
                      />
                    </ContentBlock>

                    <ContentBlock cols={2}>
                      <InputBlock
                        label="Referenced Inquiry"
                        placeholder="e.g. RFQ #00001"
                        errorMessage={formik.errors.referencedInquiry}
                        isDisabled={isDisabled}
                        inputState={`${helper.getInputClasses(formik, 'referencedInquiry')}`}
                        {...formik.getFieldProps('referencedInquiry')}
                      />
                    </ContentBlock>

                    <ContentBlock cols={2}>
                      <InputBlock
                        label="Estimated Delivery"
                        placeholder="e.g. 10-12 WEEKS ARO"
                        errorMessage={formik.errors.estimatedDelivery}
                        isDisabled={isDisabled}
                        inputState={`${helper.getInputClasses(formik, 'estimatedDelivery')}`}
                        {...formik.getFieldProps('estimatedDelivery')}
                      />
                    </ContentBlock>

                    <ContentBlock cols={2}>
                      <InputBlock
                        label="F.O.B."
                        placeholder="e.g. ORIGIN"
                        errorMessage={formik.errors.fob}
                        isDisabled={isDisabled}
                        inputState={`${helper.getInputClasses(formik, 'fob')}`}
                        {...formik.getFieldProps('fob')}
                      />
                    </ContentBlock>

                    <ContentBlock cols={2}>
                      <InputBlock
                        label="Expiration"
                        placeholder="e.g. NET 30"
                        errorMessage={formik.errors.expiration}
                        isDisabled={isDisabled}
                        inputState={`${helper.getInputClasses(formik, 'expiration')}`}
                        {...formik.getFieldProps('expiration')}
                      />
                    </ContentBlock>

                    <ContentBlock cols={12}>
                      <TextAreaBlock
                        label="Ship To"
                        placeholder="e.g. 1000 Test St, Baton Rouge, LA 70801, USA"
                        errorMessage={formik.errors.shipTo}
                        isDisabled={isDisabled}
                        inputState={`${helper.getInputClasses(formik, 'shipTo')}`}
                        {...formik.getFieldProps('shipTo')}
                      />
                    </ContentBlock>
                    {
                      !isDisabled
                      && (
                        <>
                          <ContentBlock className="mt-30">
                            <ContentHeader
                              title="Add Items"
                              headerSize="md"
                              className="alt-font fw-600 primary-lighter--clr pb-15"
                            />
                          </ContentBlock>

                          <ContentBlock cols={3}>
                            <SelectBlock
                              label="Licensor"
                              placeholder="Select a Licensor"
                              options={licensors}
                              isRequired
                              value={selectedLineItemFilters.licensor}
                              onChange={(opt) => {
                                opt = opt === null ? [] : opt;
                                setSelectedLineItemFilters({
                                  ...selectedLineItemFilters,
                                  licensor: opt
                                });
                                lineItemFormik.setFieldValue('licensor', opt.value);
                              }}
                            />
                          </ContentBlock>

                          <ContentBlock cols={3}>
                            <SelectBlock
                              label="Connection Type"
                              placeholder="Select a Connection Type"
                              options={connectionTypes}
                              isRequired
                              inputState={selectedLineItemFilters.licensor === null ? 'disabled' : ''}
                              value={selectedLineItemFilters.connectionType}
                              onChange={(opt) => {
                                opt = opt === null ? [] : opt;
                                setSelectedLineItemFilters({
                                  ...selectedLineItemFilters,
                                  connectionType: opt
                                });
                                lineItemFormik.setFieldValue('connectionType', opt.value);
                              }}
                            />
                          </ContentBlock>

                          <ContentBlock cols={3}>
                            <SelectBlock
                              label="Material Group"
                              placeholder="Select a Material Group"
                              options={materialGroups}
                              isRequired
                              inputState={selectedLineItemFilters.connectionType === null ? 'disabled' : ''}
                              value={selectedLineItemFilters.materialGroup}
                              onChange={(opt) => {
                                opt = opt === null ? [] : opt;
                                setSelectedLineItemFilters({
                                  ...selectedLineItemFilters,
                                  materialGroup: opt
                                });
                                lineItemFormik.setFieldValue('materialGroup', opt.value);
                              }}
                            />
                          </ContentBlock>

                          <ContentBlock cols={3}>
                            <SelectBlock
                              label="Size"
                              placeholder="Select a Size"
                              options={sizes}
                              isRequired
                              inputState={selectedLineItemFilters.materialGroup === null ? 'disabled' : ''}
                              value={selectedLineItemFilters.size}
                              onChange={(opt) => {
                                opt = opt === null ? [] : opt;
                                setSelectedLineItemFilters({
                                  ...selectedLineItemFilters,
                                  size: opt
                                });
                                lineItemFormik.setFieldValue('size', opt.value);
                              }}
                            />
                          </ContentBlock>

                          <ContentBlock cols={3}>
                            <SelectBlock
                              label="Weight"
                              placeholder="Select a Weight"
                              options={weights}
                              isRequired
                              inputState={selectedLineItemFilters.size === null ? 'disabled' : ''}
                              value={selectedLineItemFilters.weight}
                              onChange={(opt) => {
                                opt = opt === null ? [] : opt;
                                setSelectedLineItemFilters({
                                  ...selectedLineItemFilters,
                                  weight: opt
                                });
                                lineItemFormik.setFieldValue('weight', opt.value);
                              }}
                            />
                          </ContentBlock>

                          <ContentBlock cols={3}>
                            <InputBlock
                              label="Quantity"
                              placeholder="e.g. 5-10"
                              errorMessage={lineItemFormik.errors.quantity}
                              inputState={`${helper.getInputClasses(lineItemFormik, 'quantity')}`}
                              {...lineItemFormik.getFieldProps('quantity')}
                            />
                          </ContentBlock>

                          <ContentBlock cols={4}>
                            <SelectBlock
                              label="Equipment"
                              placeholder="Select a Equipment"
                              options={constants.TENARIS_EQUIPMENTS}
                              isRequired
                              value={selectedLineItemFilters.equipment}
                              onChange={(opt) => {
                                opt = opt === null ? [] : opt;
                                setSelectedLineItemFilters({
                                  ...selectedLineItemFilters,
                                  equipment: opt
                                });
                                lineItemFormik.setFieldValue('equipment', opt.value);
                              }}
                            />
                          </ContentBlock>

                          {/* <ContentBlock cols={
                            selectedLineItemFilters.licensor
                              && selectedLineItemFilters.licensor.isDifferent ? 2 : 3
                          }
                          >
                            <InputBlock
                              label="Complexity Multiplier"
                              placeholder="e.g. 5-10"
                              type="number"
                              errorMessage={lineItemFormik.errors.complexityMultiplier}
                              inputState={`${
                                helper.getInputClasses(lineItemFormik, 'complexityMultiplier')
                              }`}
                              {...lineItemFormik.getFieldProps('complexityMultiplier')}
                            />
                          </ContentBlock> */}

                          <ContentBlock cols={2}>
                            <InputBlock
                              label="Cost"
                              placeholder="e.g. $149"
                              type="number"
                              errorMessage={lineItemFormik.errors.amount}
                              inputState={`${helper.getInputClasses(lineItemFormik, 'amount')}`}
                              {...lineItemFormik.getFieldProps('amount')}
                            />
                          </ContentBlock>

                          <ContentBlock>
                            <TextAreaBlock
                              label="Comments"
                              className="sm"
                              errorMessage={lineItemFormik.errors.comments}
                              inputState={`${helper.getInputClasses(lineItemFormik, 'comments')}`}
                              {...lineItemFormik.getFieldProps('comments')}
                            />
                          </ContentBlock>

                          <ContentBlock className="content-container--actions flex-end mt-0 pb-20">
                            <Button
                              text="Clear"
                              className="danger--bg"
                              size="xs"
                              onClick={handleResetForm}
                            />

                            <Button
                              text="Add"
                              size="xs"
                              className="primary--bg"
                              onClick={lineItemFormik.handleSubmit}
                            />
                          </ContentBlock>
                        </>
                      )
                    }
                    <CustomBlock>
                      <CustomBlock className="mt-30">
                        <ContentHeader
                          title="Line Items"
                          headerSize="md"
                          className="alt-font fw-600 primary-lighter--clr pb-15"
                        />
                      </CustomBlock>

                      <ReactTable
                        data={quote.lineItems}
                        columns={columns}
                        className="react-table-minimal fixed-height"
                        pageSizeOptions={[5, 10, 15, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                        defaultPageSize={10}
                      />
                    </CustomBlock>
                  </>
                )
              }

              {/* <ContentBlock className="content-container--actions flex-end">
                <Button
                  text="Send to Client"
                  className="info--bg"
                  onClick={() => history.push('/management/clients')}
                />
              </ContentBlock> */}

            </Section>
            {
              !isDisabled && (
                <FixedActionsBar
                  primaryActionText={quoteId ? 'Save Changes' : 'Create'}
                  secondaryActionText="Cancel"
                  optionalActionText={quoteId ? 'Email Quote' : ''}
                  optionalActionOnClick={getClientEmail}
                  primaryActionOnClick={formik.handleSubmit}
                  secondaryActionOnClick={() => history.push('/management/customers')}
                />
              )
            }
          </FormBlock>
        </Section>
      </CustomBlock>

      {/* EDIT MODAL */}
      <ModalBlock
        hasCloseAction
        centered
        isVisible={isUpdateModalVisible}
        size="md"
        contentHeader="Additional Costs"
        primaryModalActionText="Update"
        primaryModalActionColor="primary--bg"
        primaryModalActionOnClick={updateLineItemFormik.handleSubmit}
        secondaryModalActionText="Cancel"
        secondaryModalActionColor="danger--bg"
        onHide={handleLineItemUpdateModalClose}
      >
        <FormBlock onSubmit>
          <Section hasNoContainer>
            <ContentBlock>
              <InputBlock
                label="Cost"
                placeholder="e.g. $149"
                type="number"
                iconLeft={<TbCurrencyDollar size={25} className="grey--clr" />}
                errorMessage={updateLineItemFormik.errors.amount}
                inputState={`${helper.getInputClasses(updateLineItemFormik, 'amount')}`}
                {...updateLineItemFormik.getFieldProps('amount')}
              />
            </ContentBlock>

            <ContentBlock>
              <TextAreaBlock
                label="Comments (Optional)"
                className="sm"
                errorMessage={updateLineItemFormik.errors.comments}
                inputState={`${helper.getInputClasses(updateLineItemFormik, 'comments')}`}
                {...updateLineItemFormik.getFieldProps('comments')}
              />
            </ContentBlock>
          </Section>
        </FormBlock>
      </ModalBlock>

      <ModalBlock
        hasCloseAction
        centered
        isVisible={isRejectionModalVisible}
        size="md"
        contentHeader="Reject Quote"
        primaryModalActionText="Reject"
        primaryModalActionColor="primary--bg"
        primaryModalActionOnClick={handleQuoteRejection}
        secondaryModalActionText="Cancel"
        secondaryModalActionColor="danger--bg"
        onHide={() => {
          handleRejectionModalClose();
        }}
      >
        <FormBlock onSubmit>
          <Section hasNoContainer>
            <ContentBlock className="mb-15">
              <p>
                Are you sure you want to reject this quote?
                If yes, please enter the rejection reason.
              </p>
            </ContentBlock>
            <ContentBlock>
              <TextAreaBlock
                label="Rejection Reason"
                className="sm"
                value={cancellationReason}
                onChange={(e) => {
                  setCancellationReason(e.target.value);
                }}
              />
            </ContentBlock>
          </Section>
        </FormBlock>
      </ModalBlock>

      <ModalBlock
        hasCloseAction
        centered
        isVisible={isEmailModalVisible}
        size="md"
        contentHeader="Email Quote"
        primaryModalActionText="Send to Customer"
        primaryModalActionColor="primary--bg"
        primaryModalActionOnClick={() => {
          if (emailModel.emails.length > 0) {
            submitToClient();
          }
        }}
        secondaryModalActionText="Cancel"
        secondaryModalActionColor="danger--bg"
        onHide={() => setIsEmailModalVisible(false)}
      >
        <FormBlock onSubmit>
          <p> Are you sure you want to email quote to the customer? Please see email below: </p>
          <Section hasNoContainer>
            {
              emailModel.emails.map((x, i) => (
                <ContentBlock className="flex">
                  <ContentBlock cols={8}>
                    {i + 1}.
                    {x}
                  </ContentBlock>
                  <ContentBlock cols={4}>
                    <MdDelete
                      size={25}
                      className="danger--clr"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        const temp = [...emailModel.emails];
                        _.pullAt(temp, [i]);

                        setEmailModel({ ...emailModel, emails: temp });
                      }}
                    />
                  </ContentBlock>
                </ContentBlock>
              ))
            }
            <ContentBlock className="mt-30">
              <InputBlock
                label="Email"
                placeholder="e.g. rlyons@kb-industries.com"
                iconRight={<MdAddBox size={25} className={_.isEmpty(emailFormik.errors) ? 'success--clr' : 'grey--clr'} />}
                iconRightOnClick={emailFormik.handleSubmit}
                errorMessage={emailFormik.errors.email}
                inputState={`${helper.getInputClasses(emailFormik, 'email')}`}
                {...emailFormik.getFieldProps('email')}
              />
            </ContentBlock>
          </Section>
        </FormBlock>
      </ModalBlock>
    </>
  );
};

const mapStateFromProps = (state) => ({ auth: state.auth });

export default connect(mapStateFromProps, {
  ...alert.actions,
  ...confirmModal.actions
})(QuoteManagementPage);